import React from 'react';
import I18n from '@/modules/i18n';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import Status from '@/components/staffer/Grading/StatusBox/Status';
import { formattedSubmittedAt } from '@/components/staffer/Grading/StatusBox/StatusBox';
import SubmissionScore from '@/components/staffer/Grading/StatusBox/SubmissionScore';
import Text from '@/components/ui/Text';
import GameResetButton, { GameType } from '@/components/shared/Grading/Navigation/GameResetButton';
import useExerciseResult from '@/components/staffer/Grading/useExerciseResult';

const getGameType = (title: string, exerciseType: string): GameType => {
  if (exerciseType === 'ReadingGame') return 'reading_game';
  if (exerciseType === 'Challenge') return 'challenge';
  if (title.toLowerCase().includes('vocab')) return 'vocabulary_game';
  if (title.toLowerCase().includes('state capitals')) return 'state_capitals';

  return null;
};

const GameStatusBox = () => {
  const {
    assignment,
    isTeacher,
    programId,
    questionAnswers,
    student,
    submission,
  } = useGradingStore();
  const { data: exerciseResult } = useExerciseResult();

  if (!(student && questionAnswers && assignment && submission)) return null;
  if (!assignment) return null;

  const gameId = assignment.assignment_details.exercise_id.toString();
  const gameType = getGameType(assignment.assignment_details.title, assignment.assignment_details.exercise_type);
  const searchParams = new URLSearchParams(window.location.search);
  const classroomId = searchParams.get('classroom_id');

  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-flex tw-flex-col tw-gap-2">
        <Text variant="body" weight="bold">{`${student.first_name} ${student.last_name}`}</Text>
        <div className="tw-flex tw-flex-col">
          <div className="tw-flex tw-gap-0.5">
            <Text className="tw-m-0" size="sm" variant="body" weight="bold">{I18n.t('status')}:</Text>
            <Status completedText={I18n.t('completed')} />
          </div>
        </div>
        <SubmissionScore
          classNames={{
            label: 'tw-mb-0',
            root: 'tw-flex-row tw-justify-start tw-gap-1',
          }}
          editable={false}
          labelText={I18n.t('total_score')}
        />
      </div>
      <div className="tw-flex tw-flex-col tw-items-end">
        <Text size="sm" variant="body">Answered on: {formattedSubmittedAt(submission.submitted_at)}</Text>
        {exerciseResult && isTeacher && (
          <div className="tw-mt-1">
            <GameResetButton
              classroomId={classroomId}
              exerciseResultId={exerciseResult.id}
              gameId={gameId}
              gameType={gameType}
              programId={programId}
              submissionId={submission.id}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default GameStatusBox;
